import { render, staticRenderFns } from "./_pragmatic.vue?vue&type=template&id=758ad135&lang=pug&"
import script from "./_pragmatic.vue?vue&type=script&lang=js&"
export * from "./_pragmatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports